import getFleetOpsStaffUsersRef from './getFleetOpsStaffUsersRef';
import getUsersRef from './getUsersRef';
import getSharedContentRef from './getSharedContentRef';
import getUserContentSettingsRef from './getUserContentSettingsRef';
import getGroupsRef from './getGroupsRef';
import getUserUiStateRef from './getUserUiStateRef';

const userManagement = {
  getUsersRef,
  getFleetOpsStaffUsersRef,
  getSharedContentRef,
  getUserContentSettingsRef,
  getGroupsRef,
  getUserUiStateRef,
};

export default userManagement;
